const WrapperStyles = (theme) => ({
  root: {
    padding: theme.spacing(1),
    height: "100%",
    overflow: 'auto'
  },
});

export default WrapperStyles;
